var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('dl',_vm._l((_vm.directives),function(directive){return _c(_setup.DirectiveHelp,{key:directive,attrs:{"directive":directive,"mode":_vm.mode}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }